<template>
	<div>
		<template v-for="(item) in list">

			<template v-if="item.children && item.children.length > 0">
				<el-submenu :key="item.id" :index="`${item.permission}`">
					<template :index="item.id" slot="title">
						<i :class="`ylcs ylcs_${item.icon}`"></i>
						<span>{{ item.title }}</span>
					</template>
					<el-menu-item-group>
						<sideBar :list="item.children"></sideBar>
					</el-menu-item-group>
				</el-submenu>
			</template>

			<template v-else>
				<el-menu-item :key="item.id" :index="`${item.permission}`">
					<i :class="`ylcs ylcs_${item.icon}`"></i>
					<span>{{ item.title }}</span>
				</el-menu-item>
			</template>
		</template>
	</div>
</template>
<script>
export default {
	name: "sideBar",
	props: ['list']
};
</script>
<style lang="less" scoped>
.ylcs {
	padding-right: 10px;
}
</style>